import React from "react";

/**
 * Shared 80mm thermal-roll paper chrome: torn zigzag edges (screen only),
 * drop shadow, and the bold high-contrast base styles used by the sale and
 * purchase thermal receipts.
 */
export function ThermalPaper({ children }) {
    return (
        <div className="thermal-paper">
            <TearEdge position="top" />
            <div className="print-receipt" style={thermalStyles.container}>
                {children}
            </div>
            <TearEdge position="bottom" />

            {/* Screen-only paper effects — the tear edges are hidden in print */}
            <style>{`
                .thermal-paper {
                    width: 80mm;
                    margin: 0 auto 40px auto;
                    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.12)) drop-shadow(0 14px 28px rgba(0, 0, 0, 0.22));
                }
                @media print {
                    .thermal-paper {
                        width: 100%;
                        margin: 0;
                        filter: none;
                    }
                }
            `}</style>
        </div>
    );
}

// Zigzag torn-paper edge, as if the receipt was ripped off the printer roll
function TearEdge({ position }) {
    const width = 300;
    const height = 8;
    const tooth = 12;
    const points = [`0,0`, `${width},0`];
    for (let x = width; x > 0; x -= tooth) {
        points.push(`${x - tooth / 2},${height}`, `${x - tooth},0`);
    }
    return (
        <svg
            className="d-print-none"
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            style={{
                display: 'block',
                width: '100%',
                height: `${height}px`,
                transform: position === 'top' ? 'rotate(180deg)' : 'none',
            }}
        >
            <polygon points={points.join(' ')} fill="#fff" />
        </svg>
    );
}

// 80mm roll paper — bold, high-contrast text for thermal print heads
export const thermalStyles = {
    container: {
        width: '100%',
        padding: '5mm 3mm',
        backgroundColor: '#fff',
        color: '#000',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold',
        lineHeight: '1.35',
    },
    orgName: {
        textAlign: 'center',
        fontSize: '18px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        marginBottom: '2px',
    },
    // Address and phone under the name. Normal weight and a size down, so the
    // roll stays readable without the letterhead crowding out the ticket.
    orgDetail: {
        textAlign: 'center',
        fontSize: '11px',
        fontWeight: 'normal',
        lineHeight: '1.3',
    },
    title: {
        textAlign: 'center',
        fontSize: '15px',
        fontWeight: 'bold',
        marginBottom: '6px',
    },
    divider: {
        borderTop: '1px dashed #000',
        margin: '4px 0 8px 0',
    },
    row: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: '4px 0',
    },
    label: {
        width: '42%',
        fontSize: '12px',
        paddingRight: '6px',
    },
    value: {
        width: '58%',
        fontSize: '13px',
        wordBreak: 'break-word',
    },
    valueBig: {
        fontSize: '15px',
    },
    itemsBlock: {
        padding: '4px 0',
    },
    itemLine: {
        fontSize: '12px',
        padding: '2px 0',
    },
    branding: {
        textAlign: 'center',
        fontSize: '9px',
        fontWeight: 'normal',
        marginTop: '4px',
    },
};
